import { InvoiceType } from '@features/invoicesLegacy/types/invoiceType'

import { QueryKeys } from '../../../enums/queryKeys'
import { BillType } from '../../bills/enums/billType'
import { PayableSubject } from '../types'

const subjectToReconciliationQueryKeyMap: Record<string, QueryKeys> = {
  [InvoiceType.Invoice]: QueryKeys.InvoiceReconciliationMatches,
  [BillType.Bill]: QueryKeys.BillReconciliationMatches,
}

export const getReconciliationQueryKeyFromSubject = (subject?: PayableSubject): QueryKeys | null => {
  const subjectType = subject?.type
  if (!subjectType) {
    return null
  }

  return subjectToReconciliationQueryKeyMap[subjectType] ?? null
}
